import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';

const PermissionModeIcon: React.FC<{ value: 'Allow' | 'Deny' | 'Inherit' }> = ({ value }) => {
    switch (value) {
        case 'Allow':
            return <FontAwesomeIcon icon={faCheck} fixedWidth className="text-success" />;
        case 'Deny':
            return <FontAwesomeIcon icon={faTimes} fixedWidth className="text-danger" />;
        case 'Inherit':
            return <FontAwesomeIcon icon={faMinus} fixedWidth className="text-info" />;
        default:
            return null;
    }
};

export default PermissionModeIcon;